import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarCheck } from 'lucide-react';
import { WeekBookingsDialog } from './WeekBookingsDialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const KINDS = [['Health', '#16A34A'], ['Life', '#3B82F6'], ['Business', '#F97316']];
const fmt = (d) => new Date(`${d}T12:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

export function JumpstartWeeklySummary() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/api/admin/dashboard/jumpstart-weekly`, { withCredentials: true }).then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  if (!data) return null;
  const max = Math.max(1, ...data.weeks.map((w) => w.Health + w.Life + w.Business));
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-2xl p-5 mb-8" data-testid="jumpstart-weekly-card">
      <div className="flex items-center gap-2 mb-4">
        <CalendarCheck size={18} className="text-[#F97316]" />
        <h2 className="text-sm font-bold uppercase tracking-wider text-[#0A0F1C]">Jumpstart Sessions Booked</h2>
      </div>
      <div className="grid grid-cols-3 gap-3 mb-5">
        {KINDS.map(([k, c]) => (
          <div key={k} className="rounded-xl p-3 border" style={{ borderColor: `${c}55`, background: `${c}12` }} data-testid={`jumpstart-this-week-${k.toLowerCase()}`}>
            <div className="text-[10px] uppercase tracking-wider font-bold" style={{ color: c }}>{k} · this week</div>
            <div className="text-2xl font-bold text-[#0A0F1C]">{data.this_week[k]}</div>
          </div>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="jumpstart-weekly-table">
          <thead><tr className="text-left text-xs text-[#64748B]"><th className="py-1.5 pr-3 font-semibold">Week of</th>{KINDS.map(([k, c]) => <th key={k} className="py-1.5 px-2 font-semibold" style={{ color: c }}>{k}</th>)}<th className="py-1.5 pl-2 font-semibold w-1/3">Total</th></tr></thead>
          <tbody>
            {data.weeks.map((w, i) => {
              const t = w.Health + w.Life + w.Business;
              return (
                <tr key={w.week_start} onClick={() => setOpen({ week: w.week_start, label: i === 0 ? 'This week' : `Week of ${fmt(w.week_start)}` })} title="See who booked" className="border-t border-[#F1F5F9] cursor-pointer transition-colors hover:bg-[#F8FAFC]" data-testid={`jumpstart-week-row-${i}`}>
                  <td className="py-1.5 pr-3 whitespace-nowrap">{i === 0 ? 'This week' : fmt(w.week_start)}</td>
                  {KINDS.map(([k]) => <td key={k} className="py-1.5 px-2 font-semibold">{w[k]}</td>)}
                  <td className="py-1.5 pl-2">
                    <div className="flex items-center gap-2"><div className="flex h-2 rounded-full overflow-hidden bg-[#F1F5F9] flex-1">{KINDS.map(([k, c]) => <span key={k} style={{ width: `${(w[k] / max) * 100}%`, background: c }} />)}</div><span className="text-xs font-bold w-5 text-right">{t}</span></div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-[#64748B]">Tap any week to see who booked.</p>
      <WeekBookingsDialog week={open?.week} label={open?.label} onClose={() => setOpen(null)} />
    </div>
  );
}
